module.exports = __webpack_public_path__ + "static/media/edited.95bfa7c4.jpg";